(() => {
  if (window.__teeAutoMockupSwitchV3) return;
  window.__teeAutoMockupSwitchV3 = true;

  let desiredMockupIndex = 0;
  let correctionUntil = 0;
  let manualNavigation = false;
  let correcting = false;

  function getSetNumber(target) {
    const field = target.closest?.('.tee-field');
    if (!field) return null;

    const text = field.innerText || '';
    const match = text.match(/Set\s*(\d+)/i);

    return match ? parseInt(match[1], 10) : null;
  }

  function getDesiredIndex(setNumber) {
    // Sets 1–2 = mockup 1
    // Sets 3–4 = mockup 2
    // Sets 5–6 = mockup 3
    return Math.floor((setNumber - 1) / 2);
  }

  function getActiveMockupIndex() {
    const thumbnails = Array.from(
      document.querySelectorAll(
        '.tee-thumbnails__track .tee-thumbnail'
      )
    );

    const active = document.querySelector(
      '.tee-thumbnails__track .tee-thumbnail--active'
    );

    return active ? thumbnails.indexOf(active) : -1;
  }

  function activateDesiredMockup() {
    if (correcting || manualNavigation) return;
    if (Date.now() > correctionUntil) return;

    const thumbnails = document.querySelectorAll(
      '.tee-thumbnails__track .tee-thumbnail'
    );

    const target = thumbnails[desiredMockupIndex];
    if (!target) return;

    const activeIndex = getActiveMockupIndex();

    if (activeIndex !== desiredMockupIndex) {
      correcting = true;
      target.click();

      requestAnimationFrame(() => {
        correcting = false;
      });
    }
  }

  function handleFieldInteraction(event) {
    const setNumber = getSetNumber(event.target);
    if (!setNumber) return;

    desiredMockupIndex = getDesiredIndex(setNumber);

    // Protect the selected mockup only while Teeinblue
    // is refreshing after this personalization change.
    correctionUntil = Date.now() + 1200;

    activateDesiredMockup();
  }

  // Detect intentional manual gallery navigation BEFORE
  // Teeinblue handles the click.
  document.addEventListener(
    'pointerdown',
    event => {
      const galleryControl = event.target.closest?.(
        '.tee-slider__button, .tee-thumbnail'
      );

      if (!galleryControl) return;

      manualNavigation = true;
      correctionUntil = 0;

      // Let Teeinblue complete the navigation, then remember
      // whichever mockup the customer manually selected.
      setTimeout(() => {
        const index = getActiveMockupIndex();

        if (index >= 0) {
          desiredMockupIndex = index;
        }

        manualNavigation = false;
      }, 100);
    },
    true
  );

  document.addEventListener(
    'focusin',
    handleFieldInteraction,
    true
  );

  document.addEventListener(
    'input',
    handleFieldInteraction,
    true
  );

  document.addEventListener(
    'change',
    handleFieldInteraction,
    true
  );

  document.addEventListener(
    'click',
    event => {
      // Do not treat gallery navigation as a form interaction.
      if (
        event.target.closest?.(
          '.tee-slider__button, .tee-thumbnail'
        )
      ) {
        return;
      }

      handleFieldInteraction(event);
    },
    true
  );

  const observer = new MutationObserver(() => {
    if (manualNavigation) return;

    requestAnimationFrame(activateDesiredMockup);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();